import './ContactIconSwitch.css';
import { ReactComponent as Phone } from './phone.svg';

interface ContactIconSwitchProps {
  toggleContactHeader: () => void;
}

export default function ContactIconSwitch({
  toggleContactHeader,
}: ContactIconSwitchProps): JSX.Element {
  function handleClick() {
    toggleContactHeader();
  }

  return (
    <div className="contact-icon-switch">
      <button type="button" aria-label="Show phone number" onClick={handleClick}>
        <Phone className="contact__icon" width="21" height="21" alt="Contact us" />
      </button>
    </div>
  );
}
